import * as React from "react";
import { Badge, BadgePropsT } from "./Badge";

export type AtsBadgeT = Omit<BadgePropsT, "text" | "bgColor" | "london">;
export const AtsBadge = (props: AtsBadgeT): React.ReactElement => (
  <Badge {...props} text="ATS" bgColor="bg-blue-800" data-testid="ats-badge" />
);
